import React from "react";

const HomeSmallCard = ({ data, currentIndex,setActiveIndex,sliderRef }) => {
  if (!data || data.length === 0) return null; // Handle empty or undefined data

  const prevIndex = (currentIndex - 1 + data.length) % data.length; // Wraps to the last index if currentIndex is 0
  const nextIndex = (currentIndex + 1) % data.length;
  const handleImageClick = (index) => {
    setActiveIndex(index);
    sliderRef?.current.slickGoTo(index); // Navigate to clicked image
  };
  return (
    <div>
      <div>
        <img
          src={data[prevIndex]?.image_url}
          onClick={()=>handleImageClick(prevIndex)}
          className="w-10 h-12 object-cover object-center my-2"
        />
      </div>
      <div>
        <img
          src={data[currentIndex]?.image_url}
          onClick={()=>handleImageClick(currentIndex)}
          className="w-32 h-14 object-cover object-center my-2"
        />
      </div>
      <div>
        <img
          src={data[nextIndex]?.image_url}
          onClick={()=>handleImageClick(nextIndex)}
          className="w-10 h-12 object-cover object-center my-2"
        />
      </div>
    </div>
  );
};

export default HomeSmallCard;
